import { render, staticRenderFns } from "./TagsModal.vue?vue&type=template&id=36edd826&scoped=true"
import script from "./TagsModal.vue?vue&type=script&lang=js"
export * from "./TagsModal.vue?vue&type=script&lang=js"
import style0 from "./TagsModal.vue?vue&type=style&index=0&id=36edd826&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edd826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36edd826')) {
      api.createRecord('36edd826', component.options)
    } else {
      api.reload('36edd826', component.options)
    }
    module.hot.accept("./TagsModal.vue?vue&type=template&id=36edd826&scoped=true", function () {
      api.rerender('36edd826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/TagsModal.vue"
export default component.exports